import { render, staticRenderFns } from "./ContractFlowPairDisplay.vue?vue&type=template&id=00bdac20&"
import script from "./ContractFlowPairDisplay.vue?vue&type=script&lang=js&"
export * from "./ContractFlowPairDisplay.vue?vue&type=script&lang=js&"
import style0 from "./ContractFlowPairDisplay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports